import { FC } from 'react'
import { ReccurencePattern } from '../../formComponents'

import {
  getHasReoccurence,
  ModalSectionProps,
  RotaPatternModalType,
} from '../utils'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

export const ReccurencePatternSection: FC<
  ModalSectionProps & {
    type?: RotaPatternModalType
  }
> = ({ type, formData, setFormData }) => {
  const handleFrequencyValue = (value?: string) => {
    setFormData?.((prev: any) => ({ ...prev, frequency: value }))
  }

  const handleInteralValue = (value?: number) => {
    setFormData?.((prev: any) => ({ ...prev, interval: value }))
  }
  const handleDaysValue = (value?: string[]) => {
    setFormData?.((prev: any) => ({ ...prev, specificDays: value }))
  }

  const { t } = useTranslation()

  const frequencyValue = formData?.frequency

  const intervalValue = formData?.interval

  const specificDaysValue = formData?.specificDays

  const startMonthDay = dayjs(formData?.patternStart).format('D')

  const optimisticWeekStartDate = formData?.patternStart
    ? dayjs(formData?.patternStart).day()
    : undefined

  const hasReoccurence = getHasReoccurence(formData)

  const minDate = formData?.patternStart

  const hasEndDate = formData?.hasPatternEndDate === true

  return (
    <ReccurencePattern
      type={type}
      onFrequencyValueChange={handleFrequencyValue}
      onIntervalValueChange={handleInteralValue}
      onDaysValueChange={handleDaysValue}
      frequencyValue={frequencyValue}
      intervalValue={intervalValue}
      specificDaysValue={specificDaysValue}
      monthlyOptions={[
        {
          label: t('ON_THE_DAY_OPTIONS', {
            variable: startMonthDay,
          }),
          value: startMonthDay,
        },
      ]}
      optimisticWeekStartDate={optimisticWeekStartDate}
      hasReoccurence={hasReoccurence}
      hasEndDate={hasEndDate}
      minDate={minDate}
    />
  )
}
